import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateNotExpired',
})
export class DateNotExpiredPipe implements PipeTransform {
  transform(expiryDate?: Date | string | undefined): boolean {
    if (!expiryDate || expiryDate === 'N/A' || expiryDate === '') {
      return true;
    }
    //if expiry date is past date as compare to todays date then we return false else true
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today <= new Date(expiryDate);
  }
}
